import mitt from 'mitt';
globalThis.caiEventBus || (globalThis.caiEventBus = mitt());
globalThis.caiEventBus.once = function (eventName, listener) {
  var _wrapper = function wrapper(event) {
    globalThis.caiEventBus.off(eventName, _wrapper);
    listener(event);
  };
  return globalThis.caiEventBus.on(eventName, _wrapper);
};
globalThis.caiEventBus.publish = function (eventName, data) {
  return globalThis.caiEventBus.emit(eventName, data);
};
export var eventBus = globalThis.caiEventBus;